<template>
  <div>
    <el-form :model="data" ref="form" label-position="top" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="连接池名称 " prop="cn_name">
            <el-input v-model="data.cn_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="连接池标识" prop="cn_defn">
            <el-input v-model="data.cn_defn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="连接池类型 " prop="pt_uuid">
            <el-select
              filterable
              placeholder="请选择"
              v-model="data.pt_uuid"
              clearable
            >
              <el-option
                v-for="item in connTypeList"
                :key="item.id"
                :label="item.text"
                :value="item.id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="池大小 " prop="cn_poolsize">
            <el-input-number
              v-model.number="data.cn_poolsize"
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <component
      :is="config.defn"
      v-if="config.defn"
      v-model="config.data"
      ref="ConnComponentRef"
      :init="!data.uuid"
    ></component>
  </div>
</template>
<script>
import ConnApi from './Conn';
import CommonApi from '@/api/Common';
import CommonValidate from '@/libs/Validate';
import ConnComponent from './component/index';

let defaultData = {
  uuid: '',
  cn_name: '',
  cn_defn: '',
  cn_poolsize: 10,
  cn_conf: '{}',
  pt_uuid: '',
};
export default {
  props: {
    uuid: '',
    value: {},
  },
  components: { ...ConnComponent },
  data() {
    return {
      loadingEur: false,
      data: Object.assign({}, defaultData),
      rules: {
        cn_name: [
          { required: true, message: '这是必填字段' },
          {
            validator: CommonValidate.checkSpecificKey,
            trigger: ['blur', 'change'],
          },
          {
            validator: async (rule, value, callback) => {
              let resp = await ConnApi.checkConnName({
                uuid: this.data.uuid || 'null',
                name: value,
              });
              if (resp.exist) {
                callback();
              } else {
                callback(new Error('连接池名称重复'));
              }
            },
            trigger: ['blur'],
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符以内',
            trigger: 'blur',
          },
        ],
        cn_conf: [{ required: true, message: '这是必填字段' }],
        cn_poolsize: [
          { required: true, message: '这是必填字段' },
          {
            required: true,
            type: 'number',
            min: 1,
            max: 999,
            message: '请输入大于0小于999的数值！',
          },
        ],
        cn_defn: [
          { required: true, message: '这是必填字段' },
          {
            validator: CommonValidate.checkSpecificKey,
            trigger: ['blur', 'change'],
          },
          {
            validator: async (rule, value, callback) => {
              let resp = await ConnApi.checkConnType({
                uuid: this.data.uuid || 'null',
                type: value,
              });
              if (resp.exist) {
                callback();
              } else {
                callback(new Error('连接池标识重复'));
              }
            },
            trigger: ['blur'],
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符以内',
            trigger: 'blur',
          },
        ],
        pt_uuid: [{ required: true, message: '请选择' }],
      },
      connTypeList: [],
      config: {
        visible: false,
        defn: '',
        data: {},
      },
    };
  },
  mounted() {
    if (this.uuid) {
      this.data.cn_name = this.value.cnname;
      this.data.cn_defn = this.value.cndefn;
      this.data.cn_poolsize = this.value.cnpoolsize;
      this.data.cn_conf = this.value.cnconf;
      this.data.pt_uuid = this.value.ptuuid;
      this.data.uuid = this.value.uuid;
      console.log('this.data.cn_conf', this.data);
      this.config.data = JSON.parse(this.data.cn_conf || '{}');
    }
    CommonApi.listConnType().then((resp) => {
      this.connTypeList = resp.connTypeList.map((v) =>
        Object.assign(v, { disabled: v.defn === 'DB' })
      );
      this.initConnConfig();
    });
  },
  watch: {
    'data.pt_uuid': 'initConnConfig',
  },
  methods: {
    initConnConfig() {
      if (this.data.pt_uuid && this.connTypeList.length > 0) {
        let idx = this.connTypeList.findIndex(
          (item) => item.id === this.data.pt_uuid
        );
        this.config.defn = this.connTypeList[idx].defn;
      } else {
        this.config.defn = '';
      }
    },
    // 提交表单数据
    async submitForm() {
      try {
        await this.confirm();
        this.$emit('loading', true);
        this.data.cn_conf = JSON.stringify(this.config.data);
        await this.$refs.form.validate();
        await this.$refs.ConnComponentRef.validate();
        if (this.data.uuid) {
          await ConnApi.updateConn(this.data);
        } else {
          await ConnApi.saveConn(this.data);
        }
        this.$emit('refresh');
      } catch (error) {
        this.$emit('refresh', this.data);
      } finally {
        this.$emit('loading', false);
      }
    },
    async checkConn() {
      try {
        this.$emit('loading', true);
        this.data.cn_conf = JSON.stringify(this.config.data);
        await this.$refs.form.validate();
        await this.$refs.ConnComponentRef.validate();
        let resp = await ConnApi.checkConn(this.data);
        this.$message({
          message: resp.message,
          type: resp.result ? 'success' : 'error',
        });
      } finally {
        this.$emit('loading', false);
      }
    },
  },
};
</script>
<style></style>
